var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.can_edit)?_c('div',{staticClass:"footer-icon"},[_vm._v(" Powered by "),_c('img',{attrs:{"src":require("@/assets/logo/menulingua_logo_v2.svg")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }